import { ApiError } from './api-error';
export interface PublicationJob {
  id: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  result: { status: number; body: { error?: string; message?: string; [key: string]: unknown } } | null;
  error: string | null;
}
export class PublicationOutcomeError extends ApiError {}
export function publicationResult(job: PublicationJob) {
  if (job.status === 'failed') throw new PublicationOutcomeError(500, 'publication_failed', job.error ?? 'Publication failed. Nothing was published.');
  if (job.status !== 'completed') return null;
  if (!job.result) throw new ApiError(502, 'publication_result_missing');
  if (job.result.status >= 400) throw new PublicationOutcomeError(job.result.status, job.result.body.error ?? 'publication_refused', job.result.body.message, job.result.body);
  return job.result.body;
}
export async function followPublication(start: () => Promise<{ job?: PublicationJob }>,
  read: (id: string) => Promise<{ job: PublicationJob | null }>, pause = () => new Promise(resolve => setTimeout(resolve, 2000))) {
  let job: PublicationJob | undefined;
  for (;;) {
    try {
      if (!job) {
        const response = await start();
        job = response.job;
        if (!job) return response;
      }
      for (;;) {
        const result = publicationResult(job);
        if (result) return result;
        await pause();
        job = (await read(job.id)).job ?? job;
      }
    } catch (error) {
      if (job && ['completed', 'failed'].includes(job.status)) throw error;
      if (error instanceof ApiError && (error.status < 500 || error.code === 'publication_worker_unavailable')) throw error;
      // Reuse this exact request after transport loss; the saved receipt and graph commit together.
      await pause();
    }
  }
}
